<template>
  <div ref="header">
    <v-row
      ref="title" :class="dense ? 'px-5' : ['px-5', 'pt-4', 'pb-2']"
      justify="center" align-content="center" align="center">
      <v-col :cols="labelCols" align-self="center" class="text-left ellipsis">
        <BaseTooltip v-if="tooltip" bottom>
          <template #activator="{on}">
            <span
              :style="{fontSize: '17px', letterSpacing: '1px'}"
              :class="[{'smallerFont15': 22 > labelLength && labelLength > 18, 'smallerFont13': labelLength > 21}, 'widgetText--text']"
              v-on="on">
              {{ label.toUpperCase() }}
            </span>
          </template>
          <span>{{ label }}</span>
        </BaseTooltip>
        <span
          v-else
          :style="{fontSize: '17px', letterSpacing: '1px'}"
          :class="[{'smallerFont15': 22 > labelLength && labelLength > 18, 'smallerFont13': labelLength > 21}, 'widgetText--text']">
          {{ label.toUpperCase() }}
        </span>
      </v-col>
      <v-col :cols="12 - labelCols" class="text-right widgetText--text">
        <v-progress-circular
          v-show="circularLoading"
          color="elements" :size="20" :width="2"
          indeterminate />
        <slot name="count" />
        <slot name="info" />
        <slot name="zoom" />
        <slot name="edit" />
        <slot name="bulkedit" />
        <slot name="selectOptions" />
        <slot name="dropdown" />
        <slot name="clientActions" />
        <slot name="clientActionsContextMenu" />
        <slot name="anyButton" />
        <slot name="selectAll" />
        <slot name="inverseResults" />
        <slot name="zoomToAll" />
        <slot name="groupBy" />
        <slot name="hideCol" />
        <slot name="export" />
        <slot />
        <span />
        <BaseTooltip bottom>
          <template #activator="{on, attrs}">
            <v-btn
              v-bind="attrs" icon x-small
              color="widgetText" style="margin-bottom: 2px"
              class="ml-2" v-on="on"
              @click="$emit('close-parent-widget')">
              <v-icon dark>
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>{{ labels.close }}</span>
        </BaseTooltip>
      </v-col>
    </v-row>
    <v-row
      ref="divider"
      class="px-0 pt-0">
      <v-col cols="12" class="pb-1 pt-0" style="height:1px">
        <v-progress-linear
          v-show="loading"
          style="z-index:100" indeterminate color="elements" />
      </v-col>
    </v-row>
    <v-divider />
  </div>
</template>

<script>
export default {
  name: 'BaseWidgetHeader',
  props: {
    tooltip: { type: Boolean, default () { return false } },
    dense: { type: Boolean, default () { return false } },
    label: { type: String, default () { return 'Placeholder' } },
    loading: { type: Boolean, default () { return false } },
    labelCols: { type: Number, default () { return 8 } },
    circularLoading: { type: Boolean, default () { return false } },
  },
  computed: {
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).home
    },
    labelLength () {
      return this.label.length
    },
  },
}
</script>
<style scoped>
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.smallerFont15 {
  font-size: 15px !important;
}
.smallerFont13 {
  font-size: 13px !important;
}
</style>
